export const IconHoverMode = Object.freeze({
	DEFAULT: 'default',
	ALT: 'alt',
});
